import Header from "../headerAuthenticated/HeaderAuthenticated.vue"
import ResponsiveFooter from "../responsivefooter/ResponsiveFooter.vue"
import StockInfo from "./StockInfo/StockInfo.vue"
import titlebox from "./titlebox/titlebox.vue"
import TimeSeriesPlot from "./TimeSeriesPlot/TimeSeriesPlot.vue"
import Indicators from "./Indicators/Indicators.vue"
import AddToPortfolio from "./AddToPortfolio/AddToPortfolio.vue"
import spinner from "../LoadingComponent/LoadingComponent.vue"
import '../../mixins.js'
import SideBar from "../SideBar/SideBar.vue"
import CookieLaw from 'vue-cookie-law'


export default {
  name: 'assetDetail',
  components: {
    Header: Header,
    ResponsiveFooter,
    StockInfo: StockInfo,
    TimeSeriesPlot: TimeSeriesPlot,
    Indicators: Indicators,
    titlebox,
    AddToPortfolio,
    spinner,
    SideBar,
    CookieLaw
    },
  props: [],
  data () {
    return {
      isin:this.$route.params.ISIN,
      companyType: '',
      tokenValid:false,
      securityInformation: '',
      isLoaded: false,
      profile: [],
      stockInfoData: [],
      isEndpointError: false,
    }
  },
  computed: {

  },
  async created () {
    try{
      await this.verifyToken();
      if (this.tokenValid == true){
        await this.loadData();
      }
    }catch{
      this.showErrorNotification();
    }

  },
  mounted () {
  },


  methods: {
  loadData: async function() {
    try{
      console.log("test1")
      this.stockInfoData = await this.accessEndpointNoVerify('securityDetail/?isin=' + this.isin + '&format=json');
      this.profile = this.stockInfoData['profile']
      this.companyType = this.stockInfoData['profile']["security_type"];
      this.isLoaded = true;

    }catch{
      this.showErrorNotification();
    }

    }
  }
}


